module.exports = __webpack_public_path__ + "fonts/Kent4FPrinted.efb68d3.woff";